/*
 *
 * File JS per animazione
 *
 */
// import gsap from "gsap";

import ScrollMagic from "scrollmagic";

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./animate-in.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const animateIn = () => {
    let controllerAnimateIn = new ScrollMagic.Controller();
    let parallax = document.querySelectorAll(".parallaxParent");
    let fromBottom = document.querySelectorAll(".animate-from-bottom");
    let fromRight = document.querySelectorAll(".animate-from-right");
    let fromLeft = document.querySelectorAll(".animate-from-left");
    let fromTop = document.querySelectorAll(".animate-from-top");
    let scaleDown = document.querySelectorAll(".animate-scale-down");
    let scaleUp = document.querySelectorAll(".animate-scale-up");
    let fade = document.querySelectorAll(".fade");
    // var action = gsap
    //     .timeline()
    //     .from(parallax, { duration: 1, x: "-100%", ease: "back.out(2)" })
    //     .set(parallax, { color: "darkgreen" }, "-=0.2");

    if (!parallax) {
        return;
    } else {
        parallax.forEach((el) => {
            el.querySelector(".image");
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: "onEnter",
                duration: "200%",
                triggerElement: el,
            })
                .setTween(el.querySelector(".image"), {
                    y: "55%",
                })
                // .addIndicators()
                .addTo(controllerAnimateIn);
        });
    }

    if (!fromBottom) {
        return;
    } else {
        fromBottom.forEach((el) => {
            let fromBottomOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromBottomOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fromRight) {
        return;
    } else {
        fromRight.forEach((el) => {
            let fromRightOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromRightOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fromLeft) {
        return;
    } else {
        fromLeft.forEach((el) => {
            let fromLeftOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromLeftOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fromTop) {
        return;
    } else {
        fromTop.forEach((el) => {
            let fromTopOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : 50;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: fromTopOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!scaleDown) {
        return;
    } else {
        scaleDown.forEach((el) => {
            let sdOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : window.innerHeight / 4;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: sdOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!scaleUp) {
        return;
    } else {
        scaleUp.forEach((el) => {
            let suOffset =
                el.getAttribute("data-offset") != null
                    ? el.getAttribute("data-offset")
                    : window.innerHeight / 4;
            new ScrollMagic.Scene({
                triggerElement: el,
                reverse: false,
                offset: suOffset,
                triggerHook: "onEnter",
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    if (!fade) {
        return;
    } else {
        fade.forEach((el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: "onEnter",
                reverse: false,
                offset: 80,
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }
};

export default animateIn;

//--------------------------------------------------------------------//
